import React, { useEffect, useState } from "react";
import {
    Grid,
    TextField,
    Button,
    Box,
    Typography,
    Paper,
} from "@mui/material";

import LabOrdersTable from "./LabOrdersTable";
import { getOrders } from "../../services/orderService";

const LabOrders = ({ accountNumber }) => {
    debugger
    const [loading, setLoading] = useState(false);
    const [ordersData, setOrdersData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const [searchCriteria, setSearchCriteria] = useState({
        searchText: "",
        startDate: "",
        endDate: "",
        pageNumber: 0,
        pageSize: 10,
    });

    useEffect(() => {
        if (!accountNumber) return;

        const now = new Date();
        const lastYear = new Date(now);
        lastYear.setDate(now.getDate() - 365);

        const initialCriteria = {
            searchText: "",
            startDate: lastYear.toISOString().split("T")[0],
            endDate: now.toISOString().split("T")[0],
            pageNumber: 0,
            pageSize: 10,
        };

        setSearchCriteria(initialCriteria);
        fetchOrders(initialCriteria);
    }, [accountNumber]);

    const fetchOrders = async (criteria) => {
        if (!accountNumber) {
            console.warn("Skipping fetch: accountNumber not available yet");
            return;
        }

        try {
            setLoading(true);

            const response = await getOrders(
                criteria.startDate,
                criteria.endDate,
                accountNumber,
                criteria.pageNumber + 1,
                criteria.searchText,
                ""
            );

            console.log("Data:", response);

            setOrdersData(response?.data || []);
            setTotalPages(response?.pages || 0);
        } catch (error) {
            console.error("fetchOrders failed:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();

        const updatedCriteria = {
            ...searchCriteria,
            pageNumber: 0,
        };

        setSearchCriteria(updatedCriteria);
        fetchOrders(updatedCriteria);
    };

    const onChangePageSettings = (pageNumber, pageSize) => {
        const updatedCriteria = {
            ...searchCriteria,
            pageNumber,
            pageSize,
        };

        setSearchCriteria(updatedCriteria);
        fetchOrders(updatedCriteria);
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" mb={2}>
                Lab Orders
            </Typography>

            <Paper sx={{ p: 2, mb: 2 }}>
                <form onSubmit={handleSearchSubmit}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={5}>   {/* ← was xs={6}, gives search more room */}
                            <TextField
                                label="Search"
                                fullWidth
                                size="small"
                                value={searchCriteria.searchText}
                                onChange={(e) =>
                                    setSearchCriteria({
                                        ...searchCriteria,
                                        searchText: e.target.value,
                                    })
                                }
                            />
                        </Grid>

                        <Grid item xs={2.5}>  {/* ← was xs={2} */}
                            <TextField
                                label="From Date"
                                type="date"
                                fullWidth
                                size="small"
                                value={searchCriteria.startDate}
                                onChange={(e) =>
                                    setSearchCriteria({
                                        ...searchCriteria,
                                        startDate: e.target.value,
                                    })
                                }
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={2.5}>  {/* ← was xs={2} */}
                            <TextField
                                label="To Date"
                                type="date"
                                fullWidth
                                size="small"
                                value={searchCriteria.endDate}
                                onChange={(e) =>
                                    setSearchCriteria({
                                        ...searchCriteria,
                                        endDate: e.target.value,
                                    })
                                }
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <Button
                                fullWidth
                                variant="contained"
                                type="submit"
                                sx={{ height: "40px" }}
                            >
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <LabOrdersTable
                labOrdersData={ordersData}
                count={totalPages * searchCriteria.pageSize}
                onChange={onChangePageSettings}
                loading={loading}
            />
        </Box>
    );
};

export default LabOrders;